<template>
    <ul class="pagination" v-if="shouldShowPagination">
        <li v-if="pagination.links.previous" class="pagination-previous">
            <a :href="addToQueryString('page', pagination.current_page - 1)" 
               @click.prevent="setPage(pagination.current_page - 1)" 
               aria-label="previous" 
               class="pagination-link previous page">
               Previous <i>Page</i>
            </a>
        </li>

        <li class="page-item" v-if="showLeadingEllipsis">
            <span class="pagination-ellipsis">&hellip;</span>
        </li>

        <li class="page-item" 
            v-for="i in pageRange" 
            v-if="pagination.total_pages > 1">
            <a :href="addToQueryString('page', i)" 
               :data-number="i" 
               aria-label="current page" 
               aria-current="page" 
               class="pagination-link" 
               :class="{ 'current' : pagination.current_page == i }" 
               @click.prevent="setPage(i)">
               {{ i }}
            </a>
        </li>

        <li class="page-item" v-if="showTrailingEllipsis">
            <span class="pagination-ellipsis">&hellip;</span>
        </li>

        <li v-if="pagination.links.next" class="pagination-next">
            <a :href="addToQueryString('page', pagination.current_page + 1)" 
               @click.prevent="setPage(pagination.current_page + 1)" 
               aria-label="next" 
               class="pagination-link next page">
               Next <i>Page</i>
            </a>
        </li>
    </ul>
</template>

<script>
    import helpers from '../_mixins/helpers';

    export default {
        props: {
            pagination: Object
        },
        mixins: [helpers],
        computed: {
            shouldShowPagination() {
                return this.pagination.total_pages > 1;
            },
            showLeadingEllipsis() {
                return this.pagination.current_page > 4;
            },
            showTrailingEllipsis() {
                return (this.pagination.total_pages - this.pagination.current_page) > 4;
            },
            pageRange() {
                const start = this.pagination.current_page - 3 <= 0 
                    ? 1 
                    : this.pagination.current_page - 3;
                const end = this.pagination.current_page + 3 >= this.pagination.total_pages 
                    ? this.pagination.total_pages 
                    : this.pagination.current_page + 3;
                return this.range(start, end);
            }
        },
        methods: {
            range(start, end) {
                return Array.from({ length: end - start + 1 }, (_, i) => i + start);
            },
            setPage(pageNumber) {
                this.$emit('set-page', pageNumber);
            }
        }
    }
</script>
